/** @format */

const rules = {
  admin: {
    static: ['Dashboard: read']
  }
};

export default rules;
